import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../UserContext"; // adapte le chemin

const PrivateRoute = ({ children, permissionId = null }) => {
  const { user } = useContext(UserContext);

  const isAuthenticated = !!user; // true si user existe
  const hasPermission =
    permissionId === null || user?.permission_ids?.includes(permissionId);

  if (!isAuthenticated) {
    // pas connecté → redirige vers login ou dashboard
    return <Navigate to="/login" replace />;
  }

  if (!hasPermission) {
    // connecté mais pas la permission → page unauthorized
    return <Navigate to="/login" replace />;
  }

  // connecté et autorisé
  return children;
};

export default PrivateRoute;
